import { Actions } from 'vuex-smart-module';
import { GlobalService } from '@/shared/services';
import { DateTimeService } from '@/services/time';
import { Filters, BannerFilter } from '@/types';
import GlobalGetters from './getters';
import GlobalMutations from './mutations';
import GlobalState from './state';

const globalsService = new GlobalService();
const dateService = new DateTimeService();

export default class GlobalActions extends Actions<
  GlobalState,
  GlobalGetters,
  GlobalMutations,
  // eslint-disable-next-line no-use-before-define
  GlobalActions
> {
  async get_cities() {
    try {
      const data = await globalsService.get_cities();

      this.mutations.SET_CITIES(data);
    } catch (error) {
      console.log(error);
    }
  }

  async get_regions() {
    try {
      const data = await globalsService.get_regions();

      this.mutations.SET_REGIONS(data);
    } catch (error) {
      console.log(error);
    }
  }

  async get_time() {
    try {
      const { data } = await dateService.get_time();

      this.mutations.SET_TIME(data.time);
    } catch (error) {
      console.log(error);
    }
  }

  async get_banners(filters: BannerFilter) {
    try {
      const { data } = await globalsService.get_banners(filters);

      this.mutations.SET_BANNERS(data.items);
    } catch (error) {
      console.log(error);
    }
  }

  async send_banner_id(id: number) {
    try {
      const { data } = await globalsService.send_banner_id(id);

      return data;
    } catch (error) {
      console.log(error);
    }
  }
}
